<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <layout titlePage="Campanha Bônus na Carteira">
    <div v-if="isPageLoading" class="has-text-centered">
      <base-reload :isReload="false" :dark="true" label="Carregando..." />
    </div>

    <main v-else>
      <header v-if="isParticipating" class="campaign-status-header">
        <base-icon width="24" height="24" name="painel/circle-bordered" />
        <p>Parabéns você já está participando dessa campanha.</p>
      </header>

      <section class="hero-section">
        <div class="hero-container">
          <div class="hero-content">
            <div class="hero-badge">
              <p v-if="isPartner">Campanha válida de 08/10/2026 a 31/12/2026 </p>
              <p v-else>Campanha válida a partir de 15/05/2026 </p>

              <base-icon width="24" height="24" name="painel/calendar-details-icon" />
            </div>

            <div v-if="isPartner" class="hero-texts" style="max-width: 510px;">
              <h1 >🎁 Ganhe um <span>presente extra</span> do Casar.com para
                começar a <br> vida a dois </h1>

              <p>Arrecade R$18.000 ou mais e ganhe R$120 de volta para aproveitar como quiser: um café da manhã
                especial, um bom vinho, uma massagem a dois ou aquele item que faltava na casa nova.</p>
            </div>
            <div v-else class="hero-texts">
              <h1><span>Ganhe R$120,00</span> na sua carteira</h1>

              <p>Seu casamento está chegando e liberamos uma condição exclusiva!
                Atinja a meta e receba de volta parte da taxa para usar como quiser.
              </p>
            </div>

            <div class="tooltip-container" v-if="isParticipating" :data-tooltip="'Você já está participando.'">
              <button class="button is-primary" disabled>
                Quero participar
              </button>
            </div>

            <button class="button is-primary" v-else :disabled="isSaveAcceptedLoading || !isEligible"
              @click="saveAcceptedCampaign">
              Quero participar
            </button>
          </div>

          <img v-if="isPartner" :src="CasalBrindandoImg" alt="Casal brindando">
          <img v-else :src="GiftImg" alt="Presente">
        </div>
      </section>

      <section v-if="isPartner" class="values-table-section">
        <div class="values-table-container">
          <h1>Alcance a meta e ganhe tax back</h1>

          <BonusTable class="values-table"
            :rows="[{ minValue: 'Até R$17.999', bonus: 'Não elegível' }, { minValue: 'A partir de R$18.000', bonus: 'R$120,00' }]" />

          <p>*Confira as regras</p>

          <div class="tooltip-container" v-if="isParticipating" :data-tooltip="'Você já está participando.'">
            <button class="button is-primary" disabled>
              Quero garantir meu presente
            </button>
          </div>

          <button class="button is-primary" v-else :disabled="isSaveAcceptedLoading || !isEligible"
            @click="saveAcceptedCampaign">
            Quero garantir meu presente
          </button>
        </div>
      </section>
      <section v-else class="values-table-section">
        <div class="values-table-container">
          <h1>Alcance a meta e ganhe parte da taxa de volta</h1>

          <BonusTable class="values-table"
            :rows="[{ minValue: 'Até R$6.499,99', bonus: 'Não elegível' }, { minValue: 'A partir de R$6.500', bonus: 'R$120,00' }]" />

          <p>*Confira as regras</p>

          <div class="tooltip-container" v-if="isParticipating" :data-tooltip="'Você já está participando.'">
            <button class="button is-primary" disabled>
              Quero garantir meu benefício
            </button>
          </div>

          <button class="button is-primary" v-else :disabled="isSaveAcceptedLoading || !isEligible"
            @click="saveAcceptedCampaign">
            Quero garantir meu benefício
          </button>
        </div>
      </section>

      <section v-if="isPartner" class="promotion-rules-section">
        <div class="promotion-rules-container">
          <h2 class="promotion-rules-title-mobile">Regras da campanha</h2>

          <img alt="Casal olhando tablet" :src="CoupleWithTablet" />

          <div class="promotion-rules-text">
            <h2 class="promotion-rules-title">Regras da promoção</h2>

            <div class="promotion-rules-list">
              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>Para receber parte da taxa de volta em dinheiro, é necessário arrecadar mais de R$18.000 em presentes.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>O cumprimento da meta deve ocorrer em até 10 dias após a data do casamento.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>O valor devolvido é fixo: R$ 120,00.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>Este benefício ficará disponível na sua carteira Casar.com em 20 dias corridos após o casamento.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>A campanha termina automaticamente após o recebimento do benefício.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>Campanha válida para casais elegíveis com data de casamento entre 08/10/2026 a 31/12/2026</p>
              </div>
            </div>

            <div class="promotion-rules-snackbar">
              <base-icon width="24" height="24" name="painel/filled-info-icon" />
              <div>
                <p><strong>Dica:</strong> compartilhe sua lista de presentes com os seus convidados e concentre seus presentes no Casar.com, assim você aumenta sua chance de receber esse presente</p>
                <a @click="openShareModal">Divulgar sua lista.</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-else class="promotion-rules-section">
        <div class="promotion-rules-container">
          <h2 class="promotion-rules-title-mobile">Regras da campanha</h2>

          <img alt="Casal olhando tablet" :src="CoupleWithTablet" />

          <div class="promotion-rules-text">
            <h2 class="promotion-rules-title">Regras da promoção</h2>
            <div class="promotion-rules-list">
              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>Para receber parte da taxa de volta em dinheiro, é necessário arrecadar mais de R$ 6.500 em
                  presentes.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>O cumprimento da meta deve ocorrer até 10 dias após a data do casamento.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>O valor devolvido é fixo: R$ 120,00.</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>Este benefício ficará disponível na sua carteira Casar.com em <strong>20 dias corridos após o
                    casamento.</strong></p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>A campanha vale apenas para listas com taxa padrão de 3,89%</p>
              </div>

              <div class="promotion-rules-item">
                <base-icon width="16" height="16" name='painel/check-borderless-icon' />
                <p>A campanha termina automaticamente <strong>após o recebimento do benefício.</strong></p>
              </div>
            </div>

            <div class="promotion-rules-snackbar">
              <base-icon width="24" height="24" name="painel/filled-info-icon" />
              <div>
                <p><strong>Dica:</strong> compartilhe sua lista de presentes com os seus convidados e incentive o uso do
                  Casar.com, assim você tem mais chances de receber seu benefício.</p>
                <a @click="openShareModal">Divulgar sua lista.</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="claim-bonus-section">
        <div class="claim-bonus-container">
          <div class="claim-bonus-text">
            <h2>Quando receberei o benefício?</h2>
            <p v-if="isPartner">Se você atingir a meta da promoção, o tax back será disponibilizado na sua carteira em
              até <strong>20 dias após a data do casamento.</strong></p>
            <p v-else>Se você atingir a meta da promoção, o benefício será disponibilizado na sua carteira em <strong>20
                dias
                corridos após a data do casamento.</strong></p>

            <div class="tooltip-container" v-if="isParticipating" :data-tooltip="'Você já está participando.'">
              <button class="button is-primary" disabled>
                Quero participar agora
              </button>
            </div>

            <button class="button is-primary" v-else :disabled="isSaveAcceptedLoading || !isEligible"
              @click="saveAcceptedCampaign">
              Quero participar agora
            </button>
          </div>

          <img alt="Pessoa vendo bônus do Casar.com no celular" :src="PersonWithPhone" />
        </div>
      </section>
    </main>

    <ShareWedsiteUrlModal ref="shareModal" />

    <ModalWalletBonusCampaign :isOpen="showClaimModal" @close="closeClaimModal" />
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import CoupleWithTablet from '@/assets/img/campaigns/tax-back/couple-with-tablet.png'
import PersonWithPhone from '@/assets/img/campaigns/tax-back/person-with-phone.png'
import GiftImg from '@/assets/img/campaigns/tax-back/gift.png'
import CasalBrindandoImg from '@/assets/img/campaigns/tax-back/casal-brindando.png'
import CheckIcon from '@/assets/img/check.svg'
import TaxBackCampaign from '@/lib/api/TaxBackCampaign'
import Marketing from '@/lib/api/Marketing'
import ModalWalletBonusCampaign from '@/components/Campaigns/ModalWalletBonusCampaign.vue'
import BonusTable from '@/components/Campaigns/BonusTable.vue'
import ShareWedsiteUrlModal from '@/components/Shared/ShareWedsiteUrlModal.vue'

export default {
  name: 'TaxBackLP',

  components: {
    layout,
    BonusTable,
    ShareWedsiteUrlModal,
    ModalWalletBonusCampaign
  },

  metaInfo: {
    title: 'Taxa de volta',
  },

  data() {
    return {
      PersonWithPhone,
      CoupleWithTablet,
      GiftImg,
      CasalBrindandoImg,
      CheckIcon,
      isPageLoading: true,
      showClaimModal: false,
      api: null,
      isParticipating: false,
      isEligible: false,
      isSaveAcceptedLoading: false,
      isPartner: false,
    }
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
  },

  async mounted() {
    if (this.logonToken) {
      try {
        const marketingApi = new Marketing(this.logonToken)
        this.api = new TaxBackCampaign(this.logonToken)

        const [marketingOrigin, campaignAdhesion] = await Promise.all([
          marketingApi.getMarketingOrigin(),
          this.api.getUserCampaignAdhesion()
        ])

        this.isPartner = marketingOrigin.data?.utm_source === 'parceiros'

        if (campaignAdhesion.data) {
          this.isParticipating = campaignAdhesion.data.adesao_campanha == 1
          this.isEligible = campaignAdhesion.data.elegivel_campanha == 1
          this.isPageLoading = false
        } else {
          this.loading = false
          this.redirectToHome()
        }
      } catch (error) {
        console.error(error)
      }
    }
  },

  methods: {
    openShareModal() {
      this.$refs.shareModal.open()
    },

    openClaimModal() {
      this.showClaimModal = true
    },

    closeClaimModal() {
      this.showClaimModal = false
    },

    async saveAcceptedCampaign() {
      try {
        this.isSaveAcceptedLoading = true
        const response = await this.api.saveCampaignAccept()
        if (response.data.success) {
          this.isParticipating = true
          this.openClaimModal()
        }
        this.isSaveAcceptedLoading = false
      } catch (error) {
        console.error(error)
        this.isSaveAcceptedLoading = false
      }
    },

    redirectToHome() {
      this.$router.push({ name: 'dominio' })
    },
  },
}
</script>

<style lang="scss" scoped>
.campaign-status-header {
  display: flex;
  padding: 16px 48px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  background-color: #EDFCF4;

  svg {
    color: #44CB93;
  }

  p {
    color: #374455;
    font-weight: 700;
    font-size: 16px;
  }
}

.hero-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .hero-container {
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 56px;
    padding: 84px;

    .hero-content {
      display: flex;
      flex-direction: column;
      width: 517px;
      gap: 24px;

      .hero-badge {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: fit-content;
        gap: 8px;
        padding: 12px 16px;
        border-radius: 128px;
        background-color: #FCF3F6;

        svg {
          flex-shrink: 0;
        }

        p {
          color: #E583A2;
          font-size: 16px;
          line-height: 24px;
          font-weight: 700;
        }
      }

      .hero-texts {
        display: flex;
        flex-direction: column;
        gap: 16px;

        h1 {
          font-size: 36px;
          font-weight: 700;
          line-height: 40px;
          color: #374455;

          span {
            color: #E583A2;
          }
        }

        p {
          font-size: 16px;
          line-height: 24px;
          color: #5D758D;
        }
      }

      button {
        width: fit-content;
        border-radius: 8px;
        padding: 16px;
        font-size: 18px;
        font-weight: 700;

        &:disabled {
          cursor: default;
          border: 1px solid #D4DBE3;
          background: #ECEFF2;
          color: #7D95AA;
        }
      }
    }

    img {
      width: 306px;
      height: 267px;
    }
  }
}

.values-table-section {
  width: 100%;
  background-color: #F6F7F9;
  display: flex;
  justify-content: center;
  align-items: center;

  .values-table-container {
    max-width: 1200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 64px;

    h1 {
      text-align: center;
      color: #4E637B;
      font-weight: 700;
      font-size: 28px;
      line-height: 36px;
    }

    .values-table {
      width: 620px;
      margin: 16px 0;
    }

    p {
      font-style: italic;
      text-align: center;
      color: #5D758D;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 24px;
    }

    button {
      width: fit-content;
      padding: 16px;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 700;

      &:disabled {
        cursor: default;
        border: 1px solid #D4DBE3;
        background: #ECEFF2;
        color: #7D95AA;
      }
    }
  }
}

.promotion-rules-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .promotion-rules-container {
    max-width: 1044px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 56px;
    padding: 64px 16px;

    .promotion-rules-title {
      color: #374455;
      font-size: 28px;
      line-height: 36px;
      font-weight: 700;
      display: block;
    }

    .promotion-rules-title-mobile {
      display: none;
      color: #374455;
      font-size: 22px;
      line-height: 26px;
      font-weight: 700;
    }

    .promotion-rules-text {
      display: flex;
      flex-direction: column;
      gap: 28px;

      .promotion-rules-list {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 16px;
      }

      .promotion-rules-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 13px;

        svg {
          flex-shrink: 0;
        }

        p,
        strong {
          color: #5D758D
        }
      }

      .promotion-rules-snackbar {
        display: flex;
        flex-direction: row;
        padding: 8px;
        align-items: flex-start;
        gap: 4px;
        background-color: #FCF3F6;
        border-radius: 8px;

        div {
          display: flex;
          flex-direction: column;
          gap: 4px;

          p,
          strong {
            color: #E583A2;
          }

          a {
            color: #E583A2;
            font-weight: 700;
            text-decoration: underline;
          }
        }

        svg {
          flex-shrink: 0;
          color: #E583A2 !important;
        }
      }
    }

    img {
      width: 428px;
      height: 464px;
      border-radius: 16px;
      max-width: 100%;
      height: auto;
    }
  }
}

.claim-bonus-section {
  width: 100%;
  background-color: #F6F7F9;
  display: flex;
  justify-content: center;
  align-items: center;

  .claim-bonus-container {
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 56px;
    padding: 16px 16px 24px 16px;

    img {
      width: 428px;
      height: 449px;
      border-radius: 16px;
      max-width: 100%;
      height: auto;
    }

    .claim-bonus-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 16px;
      width: 340px;

      h2 {
        font-size: 36px;
        font-weight: 700;
        line-height: 40px;
        color: #374455;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }

      p,
      strong {
        color: #5D758D;
      }

      button {
        padding: 16px;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 700;

        &:disabled {
          cursor: default;
          border: 1px solid #D4DBE3;
          background: #ECEFF2;
          color: #7D95AA;
        }
      }
    }
  }
}

@media (max-width: 900px) {

  .hero-section {
    .hero-container {
      padding: 60px 16px;
    }
  }
}

@media (max-width: 800px) {
  .campaign-status-header {
    padding: 16px;
  }

  .hero-section {
    .hero-container {
      flex-direction: column-reverse;
      gap: 24px;
      padding: 60px 16px;

      .hero-content {
        width: 380px;
        height: auto;
        align-items: center;

        .hero-badge>p {
          font-size: 14px;
          line-height: 20px;
        }

        .hero-texts {
          text-align: center;

          h1 {
            font-size: 26px;
            line-height: 28px;
          }

          p {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }


      img {
        width: 176px;
        height: 154px;
      }
    }
  }

  .values-table-section {
    .values-table-container {
      padding: 60px 16px;

      h1 {
        font-size: 22px;
      }

      .values-table {
        width: 100%;
      }
    }
  }

  .allowed-people-section {
    .allowed-people-container {
      width: 100%;
      padding: 48px 16px;

      h1 {
        font-size: 22px;
        line-height: 26px;
      }

      .allowed-people-list {
        flex-direction: column;
        gap: 24px;
      }
    }
  }

  .promotion-rules-section {
    .promotion-rules-container {
      width: 475px;
      flex-direction: column;
      gap: 32px;
      padding: 60px 16px;

      img {
        width: 328px;
        height: 355px;
      }

      .promotion-rules-title-mobile {
        display: block;
      }

      .promotion-rules-title {
        display: none;
      }

      .promotion-rules-snackbar {
        p {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }

  .claim-bonus-section {
    .claim-bonus-container {
      width: 100%;
      flex-direction: column;
      align-items: center;
      padding: 60px 16px;
      gap: 32px;

      img {
        width: 328px;
        height: 344px;
        border-radius: 12px;
      }

      .claim-bonus-text {
        width: 280px;
        align-items: center;

        h2 {
          text-align: center;
          font-size: 26px;
          line-height: 28px;
        }

        p {
          text-align: center;
          font-size: 14px;
          line-height: 20px;
        }

        button {
          width: fit-content;
        }
      }
    }
  }
}

@media (max-width: 475px) {

  .hero-section {
    .hero-container {
      .hero-content {
        width: 100%;
      }
    }
  }

  .promotion-rules-section {
    .promotion-rules-container {
      width: 100%;
    }
  }
}

@media (max-width: 360px) {
  .promotion-rules-section {
    .promotion-rules-container {
      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .claim-bonus-section {
    .claim-bonus-container {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

.tooltip-container {
  position: relative;
  display: inline-flex;
  cursor: not-allowed;
  width: fit-content;

  &:hover::after {
    visibility: visible;
    opacity: 1;
    transform: scale(1) translateY(-50%);
  }

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    z-index: 10;

    top: 50%;
    left: 100%;
    margin-left: 10px;
    background: #ffffff;
    color: #374455;
    font-weight: 700;
    border: 1px solid #D4DBE3;
    border-radius: 8px;
    padding: 8px;
    font-size: 14px;
    white-space: nowrap;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transform: scale(0.9) translateY(-50%);
    transition: all 0.2s ease;
  }
}

@media (max-width: 800px) {
  .tooltip-container {
    &:hover::after {
      transform: scale(1) translateX(-50%);
    }

    &::after {
      top: auto;
      bottom: 100%;
      left: 50%;
      margin-left: 0;
      margin-bottom: 10px;
      transform: scale(0.9) translateX(-50%);
    }
  }
}
</style>
